import { useState, useEffect } from 'react';

/**
 * Media query string for mobile viewport detection.
 * Matches viewports ≤ 768px, consistent with the project's CSS breakpoints.
 * @type {string}
 */
const MOBILE_QUERY = '(max-width: 768px)';

/**
 * Hook que detecta si el viewport actual es móvil (≤ 768px).
 * Usa window.matchMedia con listener de cambios en tiempo real.
 * Maneja SSR gracefully devolviendo false cuando window no existe.
 *
 * @returns {{ isMobile: boolean }}
 */
export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    return window.matchMedia(MOBILE_QUERY).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const mediaQuery = window.matchMedia(MOBILE_QUERY);

    const handleChange = (event) => {
      setIsMobile(event.matches);
    };

    // Set initial value in case it changed between render and effect
    setIsMobile(mediaQuery.matches);

    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return { isMobile };
};
